import { render, staticRenderFns } from "./mFooter.vue?vue&type=template&id=2ef2ebbc&scoped=true"
import script from "./mFooter.vue?vue&type=script&lang=js"
export * from "./mFooter.vue?vue&type=script&lang=js"
import style0 from "./mFooter.vue?vue&type=style&index=0&id=2ef2ebbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef2ebbc",
  null
  
)

export default component.exports